import { createReducer, on } from '@ngrx/store';
import * as UserActions from '../actions/user.actions';
import { UserInfo } from '../../../model/user.model';

export const userFeatureKey = 'user';

export interface UserState {
  currentUser: UserInfo | null;
  loading: boolean;
  error: string | null;
}

export const initialState: UserState = {
  currentUser: null,
  loading: false,
  error: null,
};

export const userReducer = createReducer(
  initialState,

  // Set user (on login)
  on(
    UserActions.setUser,
    (state, { user }): UserState => ({
      ...state,
      currentUser: user,
      error: null,
    }),
  ),

  // Update profile
  on(
    UserActions.updateProfile,
    (state): UserState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    UserActions.updateProfileSuccess,
    (state, { user }): UserState => ({
      ...state,
      currentUser: { ...state.currentUser, ...user },
      loading: false,
      error: null,
    }),
  ),
  on(
    UserActions.updateProfileFailure,
    (state, { error }): UserState => ({
      ...state,
      loading: false,
      error,
    }),
  ),

  // Update avatar
  on(
    UserActions.updateAvatar,
    (state): UserState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    UserActions.updateAvatarSuccess,
    (state, { pictureUrl }): UserState => ({
      ...state,
      currentUser: state.currentUser ? { ...state.currentUser, pictureUrl } : null,
      loading: false,
      error: null,
    }),
  ),
  on(
    UserActions.updateAvatarFailure,
    (state, { error }): UserState => ({
      ...state,
      loading: false,
      error,
    }),
  ),

  // Load profile
  on(
    UserActions.loadProfile,
    (state): UserState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    UserActions.loadProfileSuccess,
    (state, { user }): UserState => ({
      ...state,
      currentUser: user,
      loading: false,
      error: null,
    }),
  ),
  on(
    UserActions.loadProfileFailure,
    (state, { error }): UserState => ({
      ...state,
      loading: false,
      error,
    }),
  ),

  // Clear user (on logout)
  on(UserActions.clearUser, (): UserState => initialState),
);
